<script>
import Modal from '../../../components/Modal.vue'
import Accordion from '../../Accordion.vue'
import AccordionItem from '../../AccordionItem.vue'
import moment from 'moment-timezone'
import VueSelect from 'vue-select';

export default {
    components: {
        Modal,
        Accordion,
        AccordionItem,
        VueSelect
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            applicationHistories: [],
            privateMessages: [],
            importantNotes: [],
            baselineOptions: [],
            baseline: null,
            baselineResults: [],
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        async opened(name) {
            try {
                this.isSaving = true;
                const response = await axios.get(`/ajax/candidate-overview/job-applications/${this.jobApplication.user_id}.json`);
                if (response.data.results) {
                    this.applicationHistories = response.data.results;
                }

            } catch (error) {
                console.error('Error uploading signature:', error);
            }

            if (name === 'client_communications') {
                try {
                    this.isSaving = true;
                    const response = await axios.get(`/ajax/candidate-overview/private-messages/${this.jobApplication.user_id}.json`);
                    if (response.data.results) {
                        this.privateMessages = response.data.results;
                    }

                } catch (error) {
                    console.error('Error uploading signature:', error);
                }
            }

            if (name === 'recruiter_notes') {
                try {
                    this.importantNotes = [];
                    this.isSaving = true;
                    const response = await axios.get(`/ajax/candidate-overview/important-notes/${this.jobApplication.user_id}.json`);
                    if (response.data.results) {
                        const failedJobs = response.data.results.failed_jobs;
                        for (let failedJobIndex in failedJobs) {
                            const failedJob = failedJobs[failedJobIndex];

                            if (failedJob.job_application_actions.length <= 0) { continue }

                            const joApplicationActions = failedJob.job_application_actions
                            for (let noteIndex in joApplicationActions) {
                                const note = joApplicationActions[noteIndex];

                                this.importantNotes.push({
                                    id: 'failedjob' + note.id,
                                    recruiter: note.user.full_name,
                                    note: note.failed_message,
                                    date: this.convertDate(note.created)
                                });
                            }
                        }

                        const notes = response.data.results.notes;
                        for (let noteIndex in notes) {
                            const note = notes[noteIndex];
                            this.importantNotes.push({
                                id: 'note' + note.id,
                                recruiter: note.creator.full_name,
                                note: note.message,
                                date: this.convertDate(note.created)
                            });
                        }
                    }

                } catch (error) {
                    console.error('Error uploading signature:', error);
                }
            }

            if (name === 'baseline_scores') {
                this.searchUserBaselineResults();
            }
        },
        convertDate(date, format = 'YYYY-MM-DD HH:mm') {
            return moment(date).tz('Africa/Johannesburg').format(format)
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        filteredBackgroundVerificationResults(backgroundVerificationResults) {
            return backgroundVerificationResults.filter(
                bvr => bvr.background_verification_spec.method === 'ifacts'
            );
        },
        updateResultStatus(id, result) {
            const formData = {
                id: id,
                result: result
            }

            axios.post(`/ajax/background-verification/update-status/${id}`, formData).then(function (response) {
                if (response.statusText !== "OK") {
                    throw new Error();
                }
            });
        },
        async searchBaselines(search) {
            search = (search !== undefined) ? search : ''
            const response = await axios.get(`/ajax/baselines/active-baselines?search=${search}&limit=1000`);
            this.baselineOptions = response.data.baselines;
        },

        async searchUserBaselineResults() {
            let queryParams = '';

            if (this.baseline) {
                queryParams += `&baseline_id=${this.baseline.id}`;
            }

            queryParams += `&user_id=${this.jobApplication.user_id}`;

            const response = await axios.get(`/ajax/baselines/user-baseline-results?${queryParams}&limit=1000`);
            this.baselineResults = response.data.baselines;
        }
    },

    watch: {
        baseline: function (val) {
            this.searchUserBaselineResults();
        }
    },
}
</script>

<template>
    <modal ref="modal" heading="Candidate Overview" class="candidat-overview-modal">
        <Accordion>
            <AccordionItem>
                <template slot="accordion-trigger">
                    Candidate Info
                </template>
                <template slot="accordion-content">
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 px-5">
                            <Accordion>
                                <AccordionItem>
                                    <template slot="accordion-trigger">
                                        Printed CV (Last Update {{ convertDate(jobApplication.user.modified) }})
                                    </template>
                                    <template slot="accordion-content">
                                        <div class="cell small-12">
                                            <iframe :src="`${jobApplication.user.cv_url}`" width="100%"
                                                height="1000px"></iframe>
                                        </div>
                                    </template>
                                </AccordionItem>
                                <AccordionItem>
                                    <template slot="accordion-trigger">
                                        Personal CV
                                    </template>
                                    <template slot="accordion-content">
                                        <div class="cell small-12">
                                            <iframe  v-if="jobApplication.user.personal_cv_url" :src="`${jobApplication.user.personal_cv_url}`" width="100%" height="1000px"></iframe>
                                            <div v-else>
                                                <h4>No Personal CV available</h4>
                                            </div>
                                        </div>
                                    </template>
                                </AccordionItem>
                                <AccordionItem>
                                    <template slot="accordion-trigger">
                                        Introduction Notes
                                    </template>
                                    <template slot="accordion-content">
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell small-12 medium-6">
                                                <div class="card p-3"
                                                    v-if="jobApplication.user.video_path_cdn !== null">
                                                    <h4>Video Note</h4>
                                                    <iframe :src="jobApplication.user.video_path_cdn" width="640"
                                                        height="360"></iframe>
                                                </div>
                                                <div class="card p-3" v-else>
                                                    <h4>No Introduction information available</h4>
                                                </div>
                                            </div>
                                            <div class="cell small-12 medium-6">
                                                <div class="card p-3"
                                                    v-if="jobApplication.user.audio_path_cdn !== null">
                                                    <h4>Audio Note</h4>
                                                    <audio controls>
                                                        <source :src="jobApplication.user.audio_path_cdn"
                                                            type="audio/mpeg">
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                </div>
                                                <div v-else class="card p-3">
                                                    <h4>No Introduction information available</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </template>
            </AccordionItem>
            <AccordionItem @opened="opened" name="application_history">
                <template slot="accordion-trigger">
                    Application History
                </template>
                <template slot="accordion-content">
                    <table>
                        <thead>
                            <tr>
                                <th>Req Number</th>
                                <th>Date Applied</th>
                                <th>Phase</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="applicationHistory in applicationHistories" :key="applicationHistory.id">
                                <td>
                                    <a :href="`/recruiter/active-requisitions/applicant/${jobApplication.id}`">
                                        Req #{{ applicationHistory.job.requisition_id }} {{ applicationHistory.job.title
                                        }}
                                    </a>
                                </td>
                                <td>{{ applicationHistory.created }}</td>
                                <td>{{ applicationHistory.application_phase }}</td>
                                <td>
                                    {{ applicationHistory.status === null ? 'still active' : applicationHistory.status
                                    }}
                                    <span v-if="applicationHistory.status === 'failed'" class="text-danger">
                                        <br />
                                        {{ applicationHistory.fail_reason }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </AccordionItem>
            <AccordionItem @opened="opened" name="client_communications">
                <template slot="accordion-trigger">
                    All Client Communications
                </template>
                <template slot="accordion-content">
                    <div class="cell small-12">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 px-5">
                                <Accordion>
                                    <AccordionItem>
                                        <template slot="accordion-trigger">
                                            Private Message
                                        </template>
                                        <template slot="accordion-content">
                                            <div class="cell small-12">
                                                <div class="grid-x grid-padding-x px-3">
                                                    <div class="bg-white cell small-12 p-0">
                                                        <Accordion>
                                                            <AccordionItem class="mb-0"
                                                                v-for="privateMessage in privateMessages"
                                                                :key="privateMessage.id">
                                                                <template slot="accordion-trigger">
                                                                    Recruiter: {{ privateMessage.recruiter.full_name }}
                                                                </template>
                                                                <template slot="accordion-content">
                                                                    <div class="bg-white">
                                                                        <table class="unstriped"
                                                                            v-if="privateMessage.sms_messages">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Sender</th>
                                                                                    <th>Content</th>
                                                                                    <th>Date Sent</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="comm in privateMessage.sms_messages"
                                                                                    :key="comm.id">
                                                                                    <td>{{ comm.user.full_name }}</td>
                                                                                    <td>{{ comm.content }}</td>
                                                                                    <td>{{ convertDate(comm.created) }}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </template>
                                                            </AccordionItem>
                                                        </Accordion>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </AccordionItem>
                                    <AccordionItem v-for="applicationHistory in applicationHistories"
                                        :key="applicationHistory.id">
                                        <template slot="accordion-trigger">
                                            Req #{{ applicationHistory.job.requisition_id }} {{
                                                applicationHistory.job.title }}
                                        </template>
                                        <template slot="accordion-content">
                                            <div class="cell small-12">
                                                <div class="grid-x grid-padding-x px-3">
                                                    <div class="bg-white cell small-12 p-0">
                                                        <table class="unstriped"
                                                            v-if="applicationHistory.job_application_communications">
                                                            <thead>
                                                                <tr>
                                                                    <th>Subject</th>
                                                                    <th>Type</th>
                                                                    <th>Recipient</th>
                                                                    <th>Date Sent</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="comm in applicationHistory.job_application_communications"
                                                                    :key="comm.id">
                                                                    <td>
                                                                        <a target="blank"
                                                                            :href="`/recruiter/active-requisitions/communications-log/${comm.id}`">
                                                                            {{ comm.subject }}
                                                                        </a>
                                                                    </td>
                                                                    <td>{{ comm.type }}</td>
                                                                    <td>{{ comm.recipient }}</td>
                                                                    <td>{{ convertDate(comm.created) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </template>
            </AccordionItem>
            <AccordionItem @opened="opened" name="recruiter_notes">
                <template slot="accordion-trigger">
                    All Recruiter Notes
                </template>
                <template slot="accordion-content">
                    <div class="cell small-12">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 px-5">
                                <Accordion>
                                    <AccordionItem>
                                        <template slot="accordion-trigger">
                                            Important Recruiter Notes on Candidate
                                        </template>
                                        <template slot="accordion-content">
                                            <table class="unstriped">
                                                <thead>
                                                    <tr>
                                                        <th>Recruiter</th>
                                                        <th>Note</th>
                                                        <th>Date Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="importantNote in importantNotes" :key="importantNote.id">
                                                        <td>{{ importantNote.recruiter }}</td>
                                                        <td>{{ importantNote.note }}</td>
                                                        <td>{{ importantNote.date }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <template slot="accordion-trigger">
                                            Recruiter Notes
                                        </template>
                                        <template slot="accordion-content">
                                            <table class="unstriped">
                                                <thead>
                                                    <tr>
                                                        <th>Req Number</th>
                                                        <th>Note</th>
                                                        <th>Recruiter</th>
                                                        <th>Date Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="applicationHistory in applicationHistories.filter(applicationHistory => applicationHistory.recruiter_notes !== null)"
                                                        :key="applicationHistory.id">
                                                        <td>
                                                            <a
                                                                :href="`/recruiter/active-requisitions/applicant/${jobApplication.id}`">
                                                                Req #{{ applicationHistory.job.requisition_id }} {{
                                                applicationHistory.job.title
                                            }}
                                                            </a>
                                                        </td>
                                                        <td>{{ applicationHistory.recruiter_notes }}</td>
                                                        <td>{{ (applicationHistory.note_creator) ?
                                                applicationHistory.note_creator.full_name :
                                                '' }}</td>
                                                        <td>{{ (applicationHistory.recruiter_notes_created) ?
                                                convertDate(applicationHistory.recruiter_notes_created) : ''
                                                            }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </template>
            </AccordionItem>
            <AccordionItem @opened="opened" name="all_ifact_checks">
                <template slot="accordion-trigger">
                    All iFacts Checks
                </template>
                <template slot="accordion-content">
                    <div class="cell small-12">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 px-5">
                                <Accordion>
                                    <AccordionItem
                                        v-for="applicationHistory in applicationHistories.filter(applicationHistory => applicationHistory.background_verification_results.length > 0)"
                                        :key="applicationHistory.id">
                                        <template slot="accordion-trigger">
                                            <div class="grid-x grid-padding-x">
                                                <div class="cell p-0">
                                                    Req #{{ applicationHistory.job.requisition_id }} {{
                                                applicationHistory.job.title }} &nbsp; <a
                                                        :href="`/recruiter/active-requisitions/applicant/${jobApplication.id}#background_verification`">Go
                                                        to application</a>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="accordion-content">
                                            <div class="cell small-12">
                                                <div class="grid-x grid-padding-x px-3">
                                                    <div class="bg-white cell small-12 p-0">
                                                        <table class="unstriped"
                                                            v-if="applicationHistory.background_verification_results.length > 0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Check</th>
                                                                    <th>Result</th>
                                                                    <th>Attachment</th>
                                                                    <th>Manual Pass/Fail Override</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="bvr in filteredBackgroundVerificationResults(applicationHistory.background_verification_results)"
                                                                    :key="bvr.id">
                                                                    <td>
                                                                        {{ bvr.background_verification_spec.title }}
                                                                    </td>
                                                                    <td>{{ bvr.result_text }}</td>
                                                                    <td>
                                                                        <a v-if="bvr.result_file_cdn !== null"
                                                                            target="_blank"
                                                                            :href="`${bvr.result_file_cdn}`"
                                                                            class="mb-3">
                                                                            {{ sliceString(bvr.result_file) }}
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        <select class="border-0"
                                                                            @change="updateResultStatus(bvr.id, bvr.result)"
                                                                            v-model="bvr.result">
                                                                            <option></option>
                                                                            <option value="pass">Pass</option>
                                                                            <option value="fail">Fail</option>
                                                                        </select>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </template>
            </AccordionItem>
            <AccordionItem @opened="opened" name="baseline_scores">
                <template slot="accordion-trigger">
                    Baseline Scores
                </template>
                <template slot="accordion-content">
                    <div class="card py-5">
                        <div class="grid-x grid-padding-x mb-2">
                            <div class="cell small-12 medium-6 px-5">
                                <vue-select label="name" :filterable="false" :options="baselineOptions"
                                    @search="searchBaselines" @open="searchBaselines" v-model="baseline">
                                    <template slot="no-options">
                                        Type to search baseline
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_role.title }} - {{ option.area }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_role.title }} - {{ option.area }}
                                        </div>
                                    </template>
                                </vue-select>
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-12 px-5">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Baseline</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="baselineResult in baselineResults" :key="baselineResult.id">
                                            <td>{{ baselineResult.baseline.company_role.title }} - {{ baselineResult.baseline.area }}</td>
                                            <td>{{ baselineResult.score }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </template>
            </AccordionItem>
        </Accordion>
    </modal>
</template>